import React from 'react';
import { connect } from 'react-redux';
import DocumentDeleteModal from 'documents/containers/modal/DocumentDeleteModal';
import asModal from '../../asModal';
import { getModalNames } from '../../store/selectors';
import modalComponents, { modalProps } from '../../modalComponents';


const ModalContainer = ({ modalNames }) => modalNames.map((modalName) => {
  // Ugly workaround for weird handleError, see https://dimando.myjetbrains.com/youtrack/issue/BI-33
  if (!modalComponents.DOCUMENT_DELETE) {
    modalComponents.DOCUMENT_DELETE = DocumentDeleteModal;
  }
  const Modal = asModal({
    name: modalName,
  })(modalComponents[modalName]);
  const props = modalProps[modalName] ? modalProps[modalName] : {};
  return <Modal key={`modal-${modalName}`} {...props} />;
});

const mapStateToProps = (state) => ({
  modalNames: getModalNames(state),
});

export default connect(mapStateToProps)(ModalContainer);
